import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FaqService {

  constructor(public http: HttpClient) { }

  getDepartmentTreeServicesList() {
		return this.http.get('https://onlinehelp.hec.gov.pk/hec-common-cms-provided-rest-services/rest/cms/getServiceList');
  }
  
  public getFaqsList(payload){
		return this.http.post('https://onlinehelp.hec.gov.pk/hec-common-cms-provided-rest-services/rest/cms/getFaq',payload)
	}
}
